import { Icon } from "@/components/common/icon/Icon";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Update = () => {
  const { t } = useTranslation();

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const hiddenFlag = sessionStorage.getItem("hideUpdate");
    if (hiddenFlag === "true") {
      setIsHidden(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem("hideUpdate", "true");
    setIsHidden(true);
  };

  if (isHidden) return null;

  return (
    <>
      <div className="p-4">
        <div className="flex items-start justify-between bg-bg rounded-[0.75rem] px-5 py-4">
          <div className="flex flex-col gap-0.5">
            <p className="text-[1.0625rem] leading-[1.375rem] font-medium text-text">
              {t("main-page.update_tg")}
            </p>
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("main-page.old_version")}
            </p>
          </div>

          <button
            onClick={handleClose}
            className="shrink-0 p-2 bg-plain-background rounded-full"
          >
            <Icon type="x" className="fill-plain-foreground/50 w-3 h-3" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Update;
